<template>
    <div>
        <div v-for="(tab, i) in tabs" :key="i" class="druckBereich pageBreak">
            <meisterschaft-print-header :lv-id="bewerb?.settings.lvId">
                <meisterschaft-print-bewerb-name :bewerb="bewerb">
                    - <span class="text-uppercase">{{tab.title}}</span>
                </meisterschaft-print-bewerb-name>
            </meisterschaft-print-header>
            <div v-for="(rundenId, i) in tab.rundenIds" :key="rundenId+i">
                <div v-if="i===0 && bewerb.getInfoText()" style="font-size: 16px; border-bottom: solid 1px #ddd; padding: 4px">
                    {{bewerb.getInfoText()}}</div>
                <meisterschaft-print-runde-tab v-if="bewerb.runden[rundenId].settings.modus==='tabelle'"
                                               :runde="bewerb.runden[rundenId]"
                                               :bewerb="bewerb" :tab="tab"
                                               class="mt-4"/>
                <div v-else>
                    <div class="title my-2">{{bewerb.runden[rundenId].settings.name}}</div>
                    <meisterschaft-print-runde-ko :runde="bewerb.runden[rundenId]"
                                                  :spiel-typ="bewerb.settings.spielTyp"/>
                    <v-divider></v-divider>
                    <meisterschaft-print-ergebnis v-if="!ergebnisNewPage &&
                                                        tab.rundenIds.length > 1 &&
                                                        i+1===tab.rundenIds.length"
                                                  :bewerb="bewerb" :new-page="false"/>
                </div>
            </div>
        </div>
        <div v-if="ergebnisNewPage && this.bewerb.settings?.modus !== 'tabelle'"
             class="druckBereich pageBreak">
            <meisterschaft-print-ergebnis :bewerb="bewerb" :new-page="true"/>
        </div>
    </div>
</template>

<script>

import MeisterschaftPrintHeader from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintHeader.vue";
import MeisterschaftPrintBewerbName from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintBewerbName.vue";
import MeisterschaftPrintRundeTab from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintRundeTab.vue";
import MeisterschaftPrintRundeKo from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintRundeKo.vue";
import MeisterschaftPrintErgebnis from "@/views/ergebnisdienst/meisterschaft/print/meisterschaftPrintErgebnis.vue";

export default {
    name: "meisterschaftPrintRunden",
    components: {MeisterschaftPrintErgebnis, MeisterschaftPrintRundeKo, MeisterschaftPrintRundeTab,
        MeisterschaftPrintBewerbName, MeisterschaftPrintHeader},
    props: ['bewerb'],
    computed: {
        tabs(){ return this.bewerb.getTabs(true) },
        ergebnisNewPage(){
            return this.bewerb.settings?.spielTyp === 'doppel' ||
                   this.bewerb.settings?.spiel?.saetze === 4
        }
    },
}
</script>

<style scoped>
    .druckBereich {
        width: 18cm; margin: auto;
    }
    .pageBreak {
        page-break-after: always;
        margin-top: 1.5cm
    }
</style>